import React from 'react';
import MDTypography from 'components/MDTypography';

const ErrorText = ({ message = 'This field is required' }) => (
    <MDTypography variant="caption" color="error" sx={{ display: 'block', mt: 0.5 }}>
        {message}
    </MDTypography>
);

export default ErrorText;
